import { createHashRouter } from "react-router-dom";
import { HOME } from "../Utils/Utils";
import { Layout } from "../layout/Layout";
import AbonnementRetourne from "../views/Abonnements/AbonnementRetourne";
import AddIntention from "../views/Abonnements/AddIntention";
import EditIntention from "../views/Abonnements/EditIntention";
import ListeAbonnements from "../views/Abonnements/ListeAbonnements";
import { ModifierAbonnement } from "../views/Abonnements/ModifierAbonnement";
import VentesSupprimees from "../views/Abonnements/VentesSupprimees";
import ValidationVente from "../views/Activation/Activation";
import Agence from "../views/Agence/Agence";
import { ListeIntention } from "../views/Agent/Liste-intention-agent";
import { CoordonnateurEquipe } from "../views/CoordonnateurEquipe/CoordonnateurEquipe";
import { DetailEquipe } from "../views/CoordonnateurEquipe/DetailEquipe";
import { Equipe } from "../views/CoordonnateurEquipe/Equipe";
import { ListeEligibilité } from "../views/Eligibilité/ListeEligibilité";
import { VerificationEligibilite } from "../views/Eligibilité/VerificationEligibilite";
import { Faq } from "../views/Faq/Faq";
import { HomePage } from "../views/Home/Client/HomePage";
import { Home } from "../views/Home/Home";
import HomeAttribution from "../views/HomeAttribution/HomeAttribution";
import HomeAttributionCoordo from "../views/HomeAttributionCoordo/HomeAttributionCoordo";
import Identification from "../views/Identification/Identification";
import Installation from "../views/Installation/Installation";
import Livraisons from "../views/Livraison/Livraisons";
import { Log } from "../views/Log/Log";
import CorbeilleMaintenance from "../views/Maintenance/GestionMaintenance";
import { NumeroFtth } from "../views/NumeroFtth/NumeroFtth";
import Paiements from "../views/Paiement/Paiements";
import Parametres from "../views/Parametres/Parametres";
import { Partenaire } from "../views/Partenaire/Partenaire";
import { PboCoupleur } from "../views/Pbo/PboCoupleur";
import { PboPort } from "../views/Pbo/PboPort";
import { PointBranchementOptique } from "../views/Pbo/PointBranchementOptique";
import { DetailsPresataire } from "../views/Prestataire/DetailsPresataire";
import { Prestataire } from "../views/Prestataire/Prestataire";
import { DetailRaccordement } from "../views/Raccordement/DetailRaccordement";
import Raccordement from "../views/Raccordement/Raccordement";
import Validation from "../views/Raccordement/Validation";
import IntentionRdv from "../views/RendezVous/IntentionRdv";
import Souscription from "../views/Souscription/Souscription";
import Survey from "../views/Survey/Survey";
import TestSouscription from "../views/TestSouscription/TestSouscription";
import { AddUserForm } from "../views/Utilisateur/Creation-utilisateur";
import Profil from "../views/Utilisateur/Profile";
import Utilisateurs from "../views/Utilisateur/Utilisateurs";
import { ZoneCouverture } from "../views/Zone-couverture/ZoneCouverture";
import { ForgotPassword } from "../views/auth/login/Forgot";
import { Login } from "../views/auth/login/Login";
import NoAccesPage from "../views/notFound/NoAcess";

export const AppRoute = createHashRouter([
  {
    path: HOME,
    element: <Layout />,
    children: [
      {
        path: `${HOME}/`,
        element: <Home />,
      },
      {
        path: `${HOME}/dashboard`,
        element: <Home />,
      },
      {
        path: `${HOME}/abonnements/:status?`,
        element: <ListeAbonnements />,
      },
      {
        path: `${HOME}/intention-rdv`,
        element: <IntentionRdv />,
      },
      {
        path: `${HOME}/liste-eligibilite`,
        element: <ListeEligibilité />,
      },
      {
        path: `${HOME}/Raccordement/souscription-liste/:id`,
        element: <DetailRaccordement />,
      },
      {
        path: `${HOME}/servey/:status?`,
        element: <Survey />,
      },
      {
        path: `${HOME}/raccordement/:status?`,
        element: <Raccordement />,
      },
      {
        path: `${HOME}/paiements`,
        element: <Paiements />,
      },
      {
        path: `${HOME}/abonnements/enregistrement-intention`,
        element: <AddIntention />,
      },
      {
        path: `${HOME}/abonnements/modifier-intention/:id`,
        element: <ModifierAbonnement />,
      },
      {
        path: `${HOME}/ventes-supprimees`,
        element: <VentesSupprimees />,
      },
      {
        path: `${HOME}/Raccordement/validation-raccordement/:id`,
        element: <Validation />,
      },
      {
        path: `${HOME}/livraisons`,
        element: <Livraisons />,
      },
      {
        path: `${HOME}/agents`,
        element: <Agence />,
      },
      {
        path: `${HOME}/agents/intention`,
        element: <ListeIntention />,
      },
      {
        path: `${HOME}/utilisateurs`,
        element: <Utilisateurs />,
      },
      {
        path: `${HOME}/profil`,
        element: <Profil />,
      },
      {
        path: `${HOME}/parametres`,
        element: <Parametres />,
      },
      {
        path: `${HOME}/zone-couverture`,
        element: <ZoneCouverture />,
      },
      {
        path: `${HOME}/numeroFtth`,
        element: <NumeroFtth />,
      },
      {
        path: `${HOME}/identification`,
        element: <Identification />,
      },
      {
        path: `${HOME}/souscription`,
        element: <Souscription />,
      },
      {
        path: `${HOME}/corbeille-rdv`,
        element: <HomeAttribution />,
      },
      {
        path: `${HOME}/corbeille-rdv-prestataire`,
        element: <HomeAttributionCoordo />,
      },
      {
        path: `${HOME}/abonnements-retournes`,
        element: <AbonnementRetourne />,
      },
      {
        path: `${HOME}/corbeille-maintenance`,
        element: <CorbeilleMaintenance />,
      },
      {
        path: `${HOME}/validation-vente`,
        element: <ValidationVente />,
      },
      {
        path: `${HOME}/test`,
        element: <TestSouscription />,
      },
      {
        path: `${HOME}/installation`,
        element: <Installation />,
      },
      {
        path: `${HOME}/logs`,
        element: <Log />,
      },
      {
        path: `${HOME}/faqs`,
        element: <Faq />,
      },
      {
        path: `${HOME}:path/poursuivre-intention/:id/:step/:pboId?/:brin?`,
        element: <EditIntention />,
      },
      {
        path: `${HOME}/equipes/:id_coordo/detail-equipe/:id/:name`,
        element: <DetailEquipe />,
      },
      {
        path: `${HOME}/equipes/coordo/:id/:name`,
        element: <Equipe />,
      },
      {
        path: `${HOME}/prestataire/details/:id/:name`,
        element: <DetailsPresataire />,
      },
      {
        path: `${HOME}/prestataire`,
        element: <Prestataire />,
      },
      {
        path: `${HOME}/equipes`,
        element: <CoordonnateurEquipe />,
      },
      {
        path: `${HOME}/creation-utilisateur`,
        element: <AddUserForm />,
      },
      {
        path: `${HOME}/pbo`,
        element: <PointBranchementOptique />,
      },
      {
        path: `${HOME}/pbo/:id/Liste-port/:nom?`,
        element: <PboPort />,
      },
      {
        path: `${HOME}/pbo/:id/Liste-coupleur/:nom?`,
        element: <PboCoupleur />,
      },
      {
        path: `${HOME}/partenaire`,
        element: <Partenaire />,
      },
    ],
  },
  {
    path: "/:idAgent?",
    element: <VerificationEligibilite />,
  },
  {
    path: `/choix-offre/:idAgent?`,
    element: <HomePage />,
  },
  {
    path: "/pas-autorise",
    element: <NoAccesPage />,
  },
  {
    path: "/static",
    element: <NoAccesPage />,
  },
  {
    path: `${HOME}/login`,
    element: <Login />,
  },
  {
    path: `${HOME}/mot-de-passe-oublie`,
    element: <ForgotPassword />,
  },
]);
